(function () {
  $(document).ready(function () {
    //GET RECIPE ID
    var id = "";
    
    //CHECK FOR QUERY STRING
    var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('id') !== null){
      id = urlParms.get('id');
    }
    else {
      var url = window.location.pathname.split("/");
      if (url.length === 4) {
        id = url[3];
      }
    }
    
    //DISPLAY THE SPECIFIED RECIPE
    if (id.length > 0){
      displayRecipe(id);
    }
    else {
      $("#recipeWrapper > .contain-width").html("<h1>Invalid Recipe</h1><h3>Sorry for the inconvenience, but this recipe does not exist.</h3><p><a class='page-back' href='/pages/recipes'>Back To Recipe List</a></p>");
    }
  });
  
  function displayRecipe(id){
    Utility.showLoadingModal();
    $.ajax({
      type: 'POST',
      url: "https://www.meyernatural.com/ecomminformation/getrecipe",
      datatype: "json",
      data: JSON.stringify({
        id: id,
        suggestedRecipesQuantity: 3
      }),
      contentType: "application/json; charset=utf-8"
    }).done(function (data) {
      //console.log(data);
      if (typeof data.recipe === "undefined") {
        $("#recipeWrapper > .contain-width").html("<h1>Invalid Recipe</h1><h3>Sorry for the inconvenience, but this recipe does not exist.</h3><p><a class='page-back' href='/pages/recipes'>Back To Recipe List</a></p>");
      }
      else {
        var recipeHtml = "";
    
        recipeHtml += "<div class='row no-gutter recipe-details-wrapper'>";
        recipeHtml += "<div class='col-md-8 col-sm-12 recipe-details-container'>";
        recipeHtml += "<div class='recipe-details'>";
        recipeHtml += "<div class='recipe-details-header'>";
        recipeHtml += "<h1>" + data.recipe.title + "</h1>";
        recipeHtml += "<hr />";
        recipeHtml += "<div id='backPrintShareContainer' class='print-hide'>";
        recipeHtml += "<a class='page-back' href='/pages/recipes'><span class='fa fa-angle-left'></span>Back To Recipe List</a>";
        recipeHtml += "<div class='print-hide print-share'>";
        recipeHtml += "<div class='print'>";
        recipeHtml += "<a>Print</a>";
        recipeHtml += "</div>";
        recipeHtml += "<div class='share'>";
        recipeHtml += "<div class='share-header'>Share</div>";
        recipeHtml += "<ul class='share-list sub-nav'>";
        recipeHtml += "<li><a class='facebook' href='https://www.facebook.com/sharer.php?u=https://www.meyermarket.com/pages/recipe/" + data.recipe.url + "' target='_blank'><span class='fab fa-facebook-f' displayText='Facebook'></span></a></li>";
        recipeHtml += "<li><a class='twitter' href='https://twitter.com/intent/tweet?url=https://www.meyermarket.com/pages/recipe/" + data.recipe.url + "' target='_blank'><span class='fab fa-twitter' displayText='Tweet'></span></a></li>";
        
        if (typeof data.recipe.detailImages[0] !== "undefined" && data.recipe.detailImages.length > 0){
          recipeHtml += "<li class='last'><a class='pinterest' href='https://pinterest.com/pin/create/bookmarklet/?url=https://www.meyermarket.com/pages/recipe/" + data.recipe.url + "&media=" + data.recipe.detailImages[0].filePath + data.recipe.detailImages[0].fileName + "' target='_blank'><span class='fab fa-pinterest-p' displayText='Pinterest'></span></a></li>";
        }
        
        recipeHtml += "</ul>";
        recipeHtml += "</div>";
        recipeHtml += "</div>";
        recipeHtml += "</div>";
        recipeHtml += "<hr class='print-hide' />";
        
        if (data.recipe.detailImages.length === 1){
          recipeHtml += "<div class='detail-image-container print-hide'>";
          recipeHtml += "<img alt='" + data.recipe.title + "' class='recipeMainImage' src='" + data.recipe.detailImages[0].filePath + data.recipe.detailImages[0].fileName + "' />";
          recipeHtml += "<div class='hidden print-yield'>";
          recipeHtml += "<p>" + data.recipe.yieldUnitDescription + ": " + data.recipe.yield + "</p>";
          recipeHtml += "<p>Prep Time: " + data.recipe.prepTime + " " + data.recipe.prepTimeMeasurementDescription + "</p>";
          recipeHtml += "<p>Cook Time: " + data.recipe.cookTime + " " + data.recipe.cookTimeMeasurementDescription + "</p>";
          recipeHtml += "<p>Total Time: " + data.recipe.totalCookTime + " " + data.recipe.totalCookTimeMeasurementDescription + "</p>";
          recipeHtml += "</div>";
          recipeHtml += "<div class='clear hidden'>&nbsp;</div>";
          recipeHtml += "</div>";
        }
        else {
          recipeHtml += "<div id='recipeDetailImages' class='carousel slide print-hide' data-ride='carousel'>";
          recipeHtml += "<ol class='carousel-indicators'>";
        
          for (let i = 0; i < data.recipe.detailImages.length; i++){
            recipeHtml += "<li data-target='#recipeDetailImages' data-slide-to='" + i + "'" + (i === 0 ? " class=active" : "") + "></li>";
          }
          
          recipeHtml += "</ol>";
          recipeHtml += "<div class='carousel-inner'>";
          
          for (let i = 0; i < data.recipe.detailImages.length; i++)
          {
            recipeHtml += "<div class='carousel-item " + (i === 0 ? "active" : "") + "'>";
            recipeHtml += "<img class='detail-image' src='" + data.recipe.detailImages[i].filePath + data.recipe.detailImages[i].fileName + "' alt='Recipe Image' />";
            recipeHtml += "</div>";
          }
          
          recipeHtml += "</div>";
          recipeHtml += "<a class='carousel-control-prev' href='#recipeDetailImages' role='button' data-slide='prev'>";
          recipeHtml += "<span class='carousel-control-prev-icon' aria-hidden='true'></span>";
          recipeHtml += "<span class='sr-only'>Previous</span>";
          recipeHtml += "</a>";
          recipeHtml += "<a class='carousel-control-next' href='#recipeDetailImages' role='button' data-slide='next'>";
          recipeHtml += "<span class='carousel-control-next-icon' aria-hidden='true'></span>";
          recipeHtml += "<span class='sr-only'>Next</span>";
          recipeHtml += "</a>";
          recipeHtml += "</div>";
        }
        
        recipeHtml += "</div>";
        recipeHtml += "<div class='recipe-ingredients row'>";
        recipeHtml += "<div class='col-md-6 col-sm-12 ingredient-list'>";
        recipeHtml += "<h3>Ingredients</h3>";
        recipeHtml += "<ul>";
        
        for (let i = 0; i < data.recipe.ingredientList.length; i++){
          recipeHtml += "<li>";
          recipeHtml += "<span class='ingredient-quantity'>" + (data.recipe.ingredientList[i].quantity === 0 ? "" : toFraction(data.recipe.ingredientList[i].quantity)) + "</span>";
          recipeHtml += " <span class='ingredient-unit'>" + (typeof data.recipe.ingredientList[i].unitOfMeasurement !== undefined ? data.recipe.ingredientList[i].unitOfMeasurement.toLowerCase() : "") + "</span>";
          recipeHtml += " <span class='ingredient-name'>" + productLink(data.recipe.ingredientList[i].name) + "</span>";
          recipeHtml += " <span class='ingredient-note'>" + (typeof data.recipe.ingredientList[i].note !== "undefined" && data.recipe.ingredientList[i].note.length > 0 ? " (" + data.recipe.ingredientList[i].note + ")" : "") + "</span>";
          recipeHtml += "</li>";
        }

        recipeHtml += "</ul>";
        recipeHtml += "</div>";
        recipeHtml += "<div class='col-md-6 col-sm-12 serving-yield'>";
        
        if (typeof data.recipe.yield !== "undefined" && data.recipe.yield !== null && data.recipe.yield > 0) {
          recipeHtml += "<div class='print-hide recipe-serving-yield'>";
          recipeHtml += "<h5>Yield</h5>";
          recipeHtml += "<div class='yield-calculator'>";
          recipeHtml += "<form class='ingredient-refresh-wrapper' id='ingredientRefreshWrapper'>";
          recipeHtml += "<label for='recipeYieldCount'>" + data.recipe.yieldUnitDescription + ":</label> ";
          recipeHtml += "<input class='recipe-yield-count' id='recipeYieldCount' maxlength='4' type='number' value='" + data.recipe.yield + "' />";
          recipeHtml += "<input class='ingredient-refresh _gt' data-action='Change Servings' data-category='Recipes' data-label='Recipes-Refresh Servings' id='ingredientRefresh' type='submit' value='Refresh' />";
          recipeHtml += "</form>";
          recipeHtml += "</div>";
          recipeHtml += "<ul>";
          recipeHtml += "<li>";
          recipeHtml += "Prep Time: " + data.recipe.prepTime + " " + data.recipe.prepTimeMeasurementDescription + "</li>";
          recipeHtml += "<li>Cook Time: " + data.recipe.cookTime + " " + data.recipe.cookTimeMeasurementDescription + "</li>";
          recipeHtml += "<li>Total Time: " + data.recipe.totalCookTime + " " + data.recipe.totalCookTimeMeasurementDescription + "</li>";
          recipeHtml += "</ul>";
          recipeHtml += "</div>";    
        }
        
        recipeHtml += "</div>";
        recipeHtml += "</div>";
        recipeHtml += "<hr class='clear preparation-divider' />";
        recipeHtml += "<h3>Preparation</h3>";
        recipeHtml += "<div class='preparation-container'>" + data.recipe.preparation + "</div>";
            
        if (typeof data.recipe.nutritionList !== "undefined" && data.recipe.nutritionList !== null && data.recipe.nutritionList.length > 0) {
          recipeHtml += "<hr />";
          recipeHtml += "<h3 class='nutriational-analysis-per-serving'>Nutritional Analysis Per Serving</h3>";
          recipeHtml += "<ul class='nutrition-list'>";
        
          for (let i = 0; i < data.recipe.nutritionList.length; i++){
            recipeHtml += "<li>" + data.recipe.nutritionList[i].typeDescription + ": " + data.recipe.nutritionList[i].quantity + data.recipe.nutritionList[i].unitOfMeasurement.toLowerCase() + "</li>";
          }
      
          recipeHtml += "</ul>";
        }
        else if (typeof data.recipe.notes !== "undefined" && data.recipe.notes.length > 0) {
          recipeHtml += data.recipe.notes;  
        }
        
        recipeHtml += "</div>";
        recipeHtml += "</div>";
        recipeHtml += "<div class='col-md-4 col-sm-12 suggested-and-button-container print-hide'>";
        recipeHtml += "<div class='suggested-recipes-container'>";
        recipeHtml += "<h3>Suggested Recipes</h3>";
        recipeHtml += "<div class='row'>";
        
        for (let i = 0; i < data.suggestedRecipes.length; i++) {
          recipeHtml += "<div class='col-md-12 suggested-recipe click-first-link'>";
          recipeHtml += "<a href='" + data.suggestedRecipes[i].url + "')'>";
          recipeHtml += "<div class='img-wrap'>";
          recipeHtml += "<div class='img-overlay'></div>";
          recipeHtml += "<img src='" + data.suggestedRecipes[i].mainImageUrl + "' alt='" + data.suggestedRecipes[i].title + "' />";
          recipeHtml += "</div>";
          recipeHtml += "<h4 class='text-center'>" + data.suggestedRecipes[i].title + "</h4>";
          recipeHtml += "</a>";
          recipeHtml += "</div>";
        }
        
        recipeHtml += "</div>";
        recipeHtml += "</div>";
        recipeHtml += "</div>";
          
        $("#recipeWrapper > .contain-width").append(recipeHtml);
              
        //PRINT RECIPE
        $(".print-share .print a").click(function () {
            window.print();
        });
        
        //REFRESH THE YIELD
        var $servingCountField = $('.recipe-yield-count');
        window.currentServingVal = $servingCountField.val();
        
        $("#ingredientRefreshWrapper").submit(function (event) {
          event.preventDefault();

          var newServingVal = $servingCountField.val();
          if (newServingVal === "" || newServingVal === 0) {
            $servingCountField.addClass('field-error');
            return;
          }

          $servingCountField.removeClass('field-error');
          if (window.currentServingVal !== newServingVal) {

            var multiplier = newServingVal / window.currentServingVal;

            $('.ingredient-quantity').each(function () {
              var $this = $(this);
              if ($this.text() !== "") {
                var currentValue = $this.text();
                var currentDecValue = new Fraction(currentValue).valueOf();
                var newValue = currentDecValue * multiplier;
                var newFraction = new Fraction(newValue);
                $this.text(newFraction.toFraction(true));
                $this.addClass('changed-value');
                window.setTimeout(function () {
                  $this.removeClass('changed-value');
                }, 2000);
              }
            });
            
            window.currentServingVal = newServingVal;
          }
        });
      }
    }).fail(function () {
      $("#recipeWrapper > .contain-width").html("<h1>Invalid Recipe</h1><h3>Sorry for the inconvenience, but an error (0x625) has occurred.  Refresh the page and try again.</h3><p><a class='page-back' href='/pages/recipes'>Back To Recipe List</a></p>");
    })
    .always(function() {
      setTimeout(
        function(){
          Utility.hideLoadingModal();
        }, 1000
      );
    });
  }
  
  function productLink(productName) {
    switch (productName.toLowerCase()) {
      case "laura's lean ground beef":
        return "<a href='/collections/lauras-lean'>" + productName + "</a>";

      case "laura's lean chicken breast":
      case "laura's lean chicken breasts":
        return "<a href='/products/lauras-lean-chicken-breast'>" + productName + "</a>";

      case "laura's 96% lean ground beef":
        return "<a href='/products/lauras-lean-96-lean-ground-beef'>" + productName + "</a>";

      case "laura's 92% lean ground beef":
        return "<a href='/products/lauras-lean-92-lean-ground-beef'>" + productName + "</a>";

      case "laura's 85% grass fed ground beef":
        return "<a href='/products/lauras-lean-85-grass-fed-ground-beef'>" + productName + "</a>";

      case "dakota organic ground beef":
        return "<a href='/collections/dakota-organic'>" + productName + "</a>";

      case "dakota organic 90/10 ground beef":
        return "<a href='/products/dakota-organic-90-10-ground-beef'>" + productName + "</a>";

      case "dakota organic 85/15 ground beef":
        return "<a href='/products/dakota-organic-85-15-ground-beef'>" + productName + "</a>";

      case "meyer natural angus":
        return "<a href='/collections/meyer-natural-angus'>" + productName + "</a>";

      case "meyer natural angus ribeye":
        return "<a href='/products/meyer-natural-angus-usda-prime-ribeye'>" + productName + "</a>";

      case "meyer natural angus new york strip":
        return "<a href='/products/meyer-natural-angus-usda-prime-new-york-strip'>" + productName + "</a>";

      case "meyer natural angus filet mignon":
        return "<a href='/products/meyer-natural-angus-usda-prime-filet-mignon'>" + productName + "</a>";

      case "meyer natural angus top sirloin":
      case "meyer natural angus top sirloin steak":
      case "meyer natural angus top sirloin steaks":
        return "<a href='/products/meyer-natural-angus-usda-prime-top-sirloin'>" + productName + "</a>";

      case "meyer heritage duroc pork":
        return "<a href='/collections/meyer-natural-pork'>" + productName + "</a>";

      case "meyer heritage duroc bacon":
        return "<a href='/products/applewood-smoked-uncured-duroc-pork-bacon'>" + productName + "</a>";

      default:
        return productName;
    }  
  }
  
  function toFraction(value) {
    var fraction = new Fraction(value);
    return fraction.toFraction(true);
  }
}());